<template>
  <div
    class="profile-link"
    @mouseenter="hovered = true"
    @mouseleave="hovered = false"
  >
    <v-card
      :to="{ name: isHrisProfile ? 'job-profile-hris-view' : 'job-profile-view', params: { id: profile.ulid } }"
      variant="outlined"
      rounded="lg"
      class="pa-3"
    >
      <p class="text-body-3 text-textLight mb-1">
        <template v-if="isHrisProfile">
          Workday profile:
        </template>
        <span class="text-body-2 font-weight-medium text-textDarkest ml-1">
          {{ profile.title }}
        </span>
      </p>
      <v-sheet
        :min-height="32"
        class="d-flex ga-4"
      >
        <JobProfileStatus
          class="align-self-center"
          :is-hris-profile="isHrisProfile"
          :status="profile.status"
        />
        <JobProfileMeta
          class="align-self-center"
          :profile="profile"
        />
        <v-spacer />
        <v-btn
          v-if="isHrisProfile"
          v-show="hovered"
          icon
          variant="text"
          size="x-small"
          title="Compare with Workday source profile"
          @click.prevent="onCompare"
        >
          <v-icon
            size="16"
            icon="mdi-file-compare"
          />
        </v-btn>
        <HideRbac :permissions="['linkDraftProfileHrisReference']">
          <v-btn
            v-show="hovered"
            icon
            variant="text"
            size="x-small"
            :title="isHrisProfile ? 'Remove link to Workday source profile' : 'Remove link to draft profile'"
            @click.prevent="onUnlink"
          >
            <v-icon
              size="16"
              icon="mdi-link-off"
            />
          </v-btn>
        </HideRbac>
      </v-sheet>
    </v-card>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useModals } from '@/stores/modals/modals';
import { useCurrentJobProfile } from '@/stores/jobProfiles/currentJobProfile';
import JobProfileMeta from '@/components/jobProfiles/editor/JobProfileMeta.vue';
import JobProfileStatus from '@/components/jobProfiles/editor/JobProfileStatus.vue';
import HideRbac from '@/components/rbac/HideRbac.vue';

const props = defineProps({
  profile: {
    type: Object,
    required: true,
  },
  isHrisProfile: {
    type: Boolean,
    default: false,
  },
});

const { setModal } = useModals();
const { jobProfile: currentProfile, readOnly } = storeToRefs(useCurrentJobProfile());
const hovered = ref(false);

const onUnlink = () => {
  setModal({
    field: 'unlinkHrisProfileConfirm',
    value: true,
    params: props.isHrisProfile ? {} : { draftProfile: props.profile },
  });
};

const onCompare = () => {
  setModal({
    field: 'jobProfileCompare',
    value: true,
    params: {
      oldSide: {
        isHrisProfile: true,
        profileUlid: props.profile.ulid,
      },
      newSide: {
        isHrisProfile: false,
        profileUlid: currentProfile.value.ulid,
        revisionUlid: currentProfile.value.last_revision_ulid,
      },
      readOnly: readOnly.value,
    },
  });
};
</script>

<style lang="less" scoped>
.v-card {
  border-color: @stroke-default;
}
</style>
